import { useState } from "react"

export const useForm = (form, callback) => {
    const [inputFields, setInputFields] = useState(form)

    const handleChange = (value, name) => {
        console.log(value, name, inputFields)
        if(value && inputFields[name].decimal) value = parseInt(value.replaceAll(',','')).toLocaleString()
        const ins = {
            ...inputFields,
            [name]: {
                ...inputFields[name],
                value,
                valueNumber: value
            }
        }
        setInputFields(ins)
        if(callback) callback(ins)
    }

    const resetInputFields = () => {
        setInputFields(form)
    }

    return [inputFields, handleChange, setInputFields, resetInputFields]
}